export default __webpack_public_path__ + "static/media/all.26b4f647.svg";